// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper":"wrapper_I6bIq","wrapper--dark":"wrapper--dark_1s+Hj","description":"description_HCmqw","list":"list_fPfcM","tag":"tag_Hd+oS","title":"title_u6Cqv"};